import { RouteComponentProps } from '@reach/router';
import SetPasswordForm from 'components/setPasswordForm.tsx/SetPasswordForm';
import React from 'react';
import Page from '../components/shared/Page';

export const SetPassword: React.FC<RouteComponentProps> = () => {
  return (
    <Page isPublic autoLogin={false}>
      <div className="SetPasswordPage">
        <div className="Content HeightContent">
          <SetPasswordForm />
        </div>
      </div>
    </Page>
  );
};
